module.exports = __webpack_public_path__ + "static/media/golf-carousel-2-480x320.fa07f358.jpg";